import {
  Bars3Icon,
  BellIcon,
  CubeTransparentIcon,
  DevDetailsButton,
  Divider,
  Flex,
  IconButton,
  Image,
  Panel,
  Spacer,
  UserProfile,
} from 'components'
import ColorModeSwitch from 'components/ColorModeSwitch'
import { useCurrentUser, useWorkspace } from 'components/providers'
import { BaseUrl, isProduction, useBreakpoint, useDisclosure, useTheme } from 'utils'
import { useEvent } from '../utils/eventUtils'
import { useCurrentPage } from '../utils/pageUtils'
import BreadCrumb from './BreadCrumb'
import CreateNewButton from './CreateNewButton'
import EntevatePermissionToggle from './EntevatePermissionToggle'
import { useFacility } from './Facility/FacilityProvider'
import SideMenuDrawer from './SideMenuDrawer'
import { useTemplate } from './template'

export default function TopBar() {
  const { theme } = useTheme()
  const currentPage = useCurrentPage()
  const user = useCurrentUser()
  const { open, onOpen, onClose } = useDisclosure()
  const breakpoint = useBreakpoint()

  return (
    <>
      <Flex flexDirection="column" hideBelow="md">
        <Flex py={3} pr={5} flexDirection="row" gap={3} w="100%" alignItems="center">
          <Panel>
            <IconButton variant="ghost" disabled icon={<BellIcon />} aria-label="Notifications" />
          </Panel>
          <CreateNewButton removeText={breakpoint <= 2} />
          {currentPage?.isChild && <BreadCrumb />}
          <Spacer />
          <Flex gap={3} alignItems="center">
            <Panel>
              <ColorModeSwitch />
            </Panel>
            <Panel height="100%" overflow="hidden" alignItems={'center'}>
              <UserProfile
                options={
                  isProduction() && user?.isAdmin
                    ? [
                        {
                          type: 'custom' as const,
                          label: <EntevatePermissionToggle px={3} pb={2} />,
                        },
                        {
                          value: 'development',
                          onClick: () => {
                            window.location.href = `${BaseUrl['dev-web']}${document.location.pathname}`
                          },
                          icon: <CubeTransparentIcon type="outline" fontSize={'sm'} />,
                          label: 'Development Site',
                        },
                      ]
                    : []
                }
              />
            </Panel>

            <TopBarDevButton />
          </Flex>
        </Flex>
        <Divider
          orientation="horizontal"
          borderColor={theme === 'light' ? 'black' : 'white'}
          opacity={theme === 'light' ? 0.1 : 0.2}
        />
      </Flex>
      <Flex direction="column" hideFrom="md">
        <Flex
          p={2}
          align="center"
          justify="space-between"
          bg={theme === 'light' ? 'rgba(255, 255, 255, 0.40)' : 'rgba(255, 255, 255, 0.10)'}
          borderBottomWidth={
            theme === 'light' ? '1px solid #DEDEDE' : '1px solid rgba(255, 255, 255, 0.1)'
          }
          boxShadow="0px 4px 10px 0px rgba(0, 0, 0, 0.10)"
          backdropFilter="blur(20px)"
        >
          <IconButton
            variant="ghost"
            aria-label="side-menu"
            icon={<Bars3Icon color={theme === 'light' ? 'rgba(103, 103, 103, 1)' : 'white'} />}
            onClick={onOpen}
          />
          <Image
            position="absolute"
            left="33vw"
            src={
              theme === 'light'
                ? '/common/momentify-logo-dark.svg'
                : '/common/momentify-logo-light.svg'
            }
            alt="momentify logo"
            height="22px"
          />
        </Flex>
        <SideMenuDrawer open={open} onClose={onClose} />
      </Flex>
    </>
  )
}

function TopBarDevButton() {
  const { workspace } = useWorkspace()
  const { facility } = useFacility()
  const { event } = useEvent()
  const { template } = useTemplate()

  if (!workspace?.id) return null

  return (
    <DevDetailsButton
      items={[
        { collection: 'Workspace', id: workspace?.id, label: 'Workspace', type: 'db' },
        { collection: 'facilities', id: facility?.id, label: 'Facility', type: 'db' },
        { collection: 'events', id: event?.id, label: 'Event', type: 'db' },
        { collection: 'templates', id: template?.id, label: 'Template', type: 'db' },
        ...(event?.id
          ? [
              {
                label: 'Event Storage',
                type: 'storage' as const,
                url: `events/${event?.id}`,
                isFolder: true,
              },
            ]
          : []),
      ]}
    />
  )
}
